import { FC, useEffect, useCallback, useMemo } from "react";
import { ApplicationEditorSortableDragStyles, Container } from "./styles";
import { ThemeProvider } from "styled-components";
import { useTheme } from "styled-components";
import { createThemeByColor } from "shared/helpers/coloring";
import FieldsEditor from "./sections/FieldsEditor";
import { TabPanel } from "shared/pages/teams/components/Panel/TabPanel";
import { useModal } from "core";
import { useTranslation } from "react-i18next";
import { Colors, Outer, useToasts } from "@brg/ui";
import NameEditor from "./sections/NameEditor";
import DocsEditor from "./sections/DocsEditor";
import { API, Endpoints } from "@brg/api";
import { ApplicationEditorActions, ApplicationEditorSelector } from "shared/reducers/ApplicationEditorSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { FormFieldType, FormType } from "./constants";
import urlApi from "shared/actions/urlApi";
import { InlineModal } from "./components/InlineModal/InlineModal";
import { normalizedCheckboxes } from "./support";

const ApplicationEditor: FC = () => {
  const { t, i18n: { language } } = useTranslation();
  const theme = useTheme();
  const modal = useModal();
  const toasts = useToasts();
  // const competitionId = useParams<{ id: string }>();
  const { theme: newTheme } = createThemeByColor(Colors.geo, theme);
  const dispatch = useDispatch();
  const { formId, fields, docs, header, description, variantOption: { visible: displayModal} } = useSelector(ApplicationEditorSelector);
  const action = ApplicationEditorActions;

  let competitionId: string | undefined = undefined;
  const pathMatch = window.location.pathname.match(/competition-edit\/([^\/]+)/i);
  if (pathMatch && pathMatch[1]) {
    competitionId = pathMatch[1];
  }

  const [isDisabled, errors] = useMemo(() => {
    const variantFields = fields?.filter((field) => field.type === FormFieldType.SelectOne || field.type === FormFieldType.SelectMultiple );
    if(variantFields?.length > 0 && variantFields?.some((field) => field.inlineVariants?.length === 0)) {
      return [true, t('applicationEditor.sections.fields.variants_required')];
    }
    return [false, undefined]
  }, [fields, docs]);

  const tabPanelErrors = useMemo(
    () => (errors ? [errors] : []),
    [errors],
  );

  const onSubmit = useCallback(() => {
    API.fetch(
      Endpoints.geograffee + '/api/forms/Update', {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          formId: formId,
          header: header,
          description: description,
          formFields: [...fields, ...docs],
        })
      }).then((res) => { 
      if (res.status === 200) {
        toasts.info('Анкета успешно обновлена');
        dispatch(action.resetState())
        modal.hide();
      } else {
        toasts.error('Ошибка при обновлении анкеты');
      }
    })
    // console.log('submit');
  }, [formId, fields, docs, header, description])

  const fetchFormData = async () => {
    if (competitionId) {
      const formData = await urlApi().fetchCompetitionFormData(competitionId, 'standard');
          dispatch(action.setInitialData({ 
              formId: formData.formId, 
              fields: formData.fields, 
              // docs: formData.docs, 
              // oldCheckboxes: 
              docs: normalizedCheckboxes(formData),
              oldCheckboxes: [],
              header: formData.header,
              description: formData.description,
              formType: FormType.base }));
      // const formData = await urlApi().fetchCompetitionFormData(competitionId, 'custom');
      // if (formData.hasFormFields) {
      //     dispatch(action.setInitialData({ 
      //         formId: formData.formId, 
      //         fields: formData.fields, 
      //         docs: formData.docs, 
      //         oldCheckboxes: [],
      //         header: formData.header,
      //         description: formData.description,
      //         formType: FormType.custom }));
      // } else {
      //     const formData = await urlApi().fetchCompetitionFormData(competitionId, 'standard');
      //     dispatch(action.setInitialData({ 
      //         formId: formData.formId, 
      //         fields: formData.fields, 
      //         // docs: formData.docs, 
      //         // oldCheckboxes: 
      //         docs: normalizedCheckboxes(formData),
      //         oldCheckboxes: [],
      //         header: formData.header,
      //         description: formData.description,
      //         formType: FormType.base }));
      // }
    }
  }

  useEffect(() => {
    fetchFormData();
  }, [competitionId]);

  useEffect(() => {
    return () => {
      dispatch(action.setVariantOption({
        visible: false,
        options: [],
      }));
    }
  }, []);

  if (displayModal) {
    return <InlineModal />
  }

  return (
    <Outer scrl={true} bgColor={'#343434'}>
      <ThemeProvider theme={newTheme}>
        <ApplicationEditorSortableDragStyles />
        <Container>
          <TabPanel 
            text={t('panel.modalText.application_editor_title')} 
            onSubmit={onSubmit}
            disabled={isDisabled}
            errors={tabPanelErrors}
            disableMargin={true}
            customBg={theme.panel.button.bg}
          />
          <NameEditor />
          <FieldsEditor />
          <DocsEditor />
     
        </Container>
      </ThemeProvider>
      
    </Outer>
  );
};

export default ApplicationEditor;
import { FC, useEffect, useCallback, useMemo } from "react";
import { ApplicationEditorSortableDragStyles, Container } from "./styles";
import { ThemeProvider } from "styled-components";
import { useTheme } from "styled-components";
import { createThemeByColor } from "shared/helpers/coloring";
import FieldsEditor from "./sections/FieldsEditor";
import { TabPanel } from "shared/pages/teams/components/Panel/TabPanel";
import { useModal } from "core";
import { useTranslation } from "react-i18next";
import { Colors, Outer, useToasts } from "@brg/ui";
import NameEditor from "./sections/NameEditor";
import DocsEditor from "./sections/DocsEditor";
import { API, Endpoints } from "@brg/api";
import { ApplicationEditorActions, ApplicationEditorSelector } from "shared/reducers/ApplicationEditorSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { FormFieldType, FormType } from "./constants";
import urlApi from "shared/actions/urlApi";
import { InlineModal } from "./components/InlineModal/InlineModal";
import { normalizedCheckboxes } from "./support";

const ApplicationEditor: FC = () => {
  const { t, i18n: { language } } = useTranslation();
  const theme = useTheme();
  const modal = useModal();
  const toasts = useToasts();
  // const competitionId = useParams<{ id: string }>();
  const { theme: newTheme } = createThemeByColor(Colors.geo, theme);
  const dispatch = useDispatch();
  const { formId, fields, docs, header, description, variantOption: { visible: displayModal} } = useSelector(ApplicationEditorSelector);
  const action = ApplicationEditorActions;

  let competitionId: string | undefined = undefined;
  const pathMatch = window.location.pathname.match(/competition-edit\/([^\/]+)/i);
  if (pathMatch && pathMatch[1]) {
    competitionId = pathMatch[1];
  }

  const [isDisabled, errors] = useMemo(() => {
    const variantFields = fields?.filter((field) => field.type === FormFieldType.SelectOne || field.type === FormFieldType.SelectMultiple );
    if(variantFields?.length > 0 && variantFields?.some((field) => field.inlineVariants?.length === 0)) {
      return [true, t('applicationEditor.sections.fields.variants_required')];
    }
    return [false, undefined]
  }, [fields, docs]);

  const tabPanelErrors = useMemo(
    () => (errors ? [errors] : []),
    [errors],
  );

  const onSubmit = useCallback(() => {
    API.fetch(
      Endpoints.geograffee + '/api/forms/Update', {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          formId: formId,
          header: header,
          description: description,
          formFields: [...fields, ...docs],
        })
      }).then((res) => { 
      if (res.status === 200) {
        toasts.info('Анкета успешно обновлена');
        dispatch(action.resetState())
        modal.hide();
      } else {
        toasts.error('Ошибка при обновлении анкеты');
      }
    })
    // console.log('submit');
  }, [formId, fields, docs, header, description])

  const fetchFormData = async () => {
    if (competitionId) {
      const formData = await urlApi().fetchCompetitionFormData(competitionId, 'standard');
          dispatch(action.setInitialData({ 
              formId: formData.formId, 
              fields: formData.fields, 
              // docs: formData.docs, 
              // oldCheckboxes: 
              docs: normalizedCheckboxes(formData),
              oldCheckboxes: [],
              header: formData.header,
              description: formData.description,
              formType: FormType.base }));
      // const formData = await urlApi().fetchCompetitionFormData(competitionId, 'custom');
      // if (formData.hasFormFields) {
      //     dispatch(action.setInitialData({ 
      //         formId: formData.formId, 
      //         fields: formData.fields, 
      //         docs: formData.docs, 
      //         oldCheckboxes: [],
      //         header: formData.header,
      //         description: formData.description,
      //         formType: FormType.custom }));
      // } else {
      //     const formData = await urlApi().fetchCompetitionFormData(competitionId, 'standard');
      //     dispatch(action.setInitialData({ 
      //         formId: formData.formId, 
      //         fields: formData.fields, 
      //         // docs: formData.docs, 
      //         // oldCheckboxes: 
      //         docs: normalizedCheckboxes(formData),
      //         oldCheckboxes: [],
      //         header: formData.header,
      //         description: formData.description,
      //         formType: FormType.base }));
      // }
    }
  }

  useEffect(() => {
    fetchFormData();
  }, [competitionId]);

  useEffect(() => {
    return () => {
      dispatch(action.setVariantOption({
        visible: false,
        options: [],
      }));
    }
  }, []);

  if (displayModal) {
    return <InlineModal />
  }

  return (
    <Outer scrl={true} bgColor={'#343434'}>
      <ThemeProvider theme={newTheme}>
        <ApplicationEditorSortableDragStyles />
        <Container>
          <TabPanel 
            text={t('panel.modalText.application_editor_title')} 
            onSubmit={onSubmit}
            disabled={isDisabled}
            errors={tabPanelErrors}
            disableMargin={true}
            customBg={theme.panel.button.bg}
          />
          <NameEditor />
          <FieldsEditor />
          <DocsEditor />
     
        </Container>
      </ThemeProvider>
      
    </Outer>
  );
};

export default ApplicationEditor;
